import { __name } from './chunk-2JTKI4GS.mjs';
import NotFoundComponent from './NotFoundComponent.mjs';

function isFunction(obj) {
  return "function" === typeof obj;
}
__name(isFunction, "isFunction");
function isObject(obj) {
  return obj !== null && typeof obj === "object";
}
__name(isObject, "isObject");
function isPromise(value) {
  return isObject(value) && "then" in value && isFunction(value.then);
}
__name(isPromise, "isPromise");
function isDOM() {
  return typeof window === "object" && typeof window.document === "object";
}
__name(isDOM, "isDOM");
function isServer() {
  return !isDOM();
}
__name(isServer, "isServer");
function isAsyncComponent(Component) {
  return Component.getInitialProps !== void 0;
}
__name(isAsyncComponent, "isAsyncComponent");
function isLoadableComponent(Component) {
  return Component.load !== void 0;
}
__name(isLoadableComponent, "isLoadableComponent");
function is404ComponentAvailable(routes) {
  return routes.find((route) => ["**", "*", "", void 0].includes(route.path)) || false;
}
__name(is404ComponentAvailable, "is404ComponentAvailable");
function get404Component(routes) {
  const match = is404ComponentAvailable(routes);
  return match ? match.component : NotFoundComponent;
}
__name(get404Component, "get404Component");
function getAllRoutes(routes) {
  return is404ComponentAvailable(routes) ? routes : [...routes, { component: NotFoundComponent }];
}
__name(getAllRoutes, "getAllRoutes");
function isJS(str) {
  return str.endsWith(".js");
}
__name(isJS, "isJS");
function isInstantTransition(transition) {
  return transition === "instant";
}
__name(isInstantTransition, "isInstantTransition");

export { get404Component, getAllRoutes, is404ComponentAvailable, isAsyncComponent, isDOM, isFunction, isInstantTransition, isJS, isLoadableComponent, isObject, isPromise, isServer };
//# sourceMappingURL=utils.mjs.map
//# sourceMappingURL=utils.mjs.map